/**
 * @module experience/landing/common
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import {
  Cart,
  CartLine,
  CartItem,
} from '@support/api/proxies/responses/api-cart-response.interface';
import { FilteredLine } from '@experience/landing/common/interfaces/filteredLine.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
import {
  CustomerAccountBillingDetails,
  LineSummary,
} from '@support/api/proxies/responses/api-2006.interface';

export class LineSelectionModel {
  /**
   * to store arrays of edited and nonedited lines
   */
  public filteredLine: FilteredLine;
  /**
   * Boolean to store if service is changed
   */
  public isPlanChanged: boolean;
  /**
   * Boolean to store if service is changed
   */
  public isServiceChanged: boolean;

  constructor(
    linesInfo: CustomerAccountBillingDetails,
    cartResponse: Cart,
    objectservice?: ObjectService
  ) {
    this.filteredLine = {
      editedLines: [],
      nonEditedLines: [],
    };
    this.getFilteredLineDetails(linesInfo, cartResponse, objectservice);
  }
  /**
   * filters line to check which have been edited
   */
  private getFilteredLineDetails(
    linesInfo: CustomerAccountBillingDetails,
    cartResponse: Cart,
    objectservice?: ObjectService
  ): void {
    if (cartResponse) {
      linesInfo.lines.forEach((accountLine: LineSummary, key: number) => {
        const cartLine = cartResponse.lines.find((line: CartLine) => {
          return accountLine.lineOfServiceId === line.id;
        });
        const isLineEdited = cartLine ? !!cartLine.isLineEdited : false;
        isLineEdited
          ? this.filteredLine.editedLines.push(accountLine)
          : this.filteredLine.nonEditedLines.push(accountLine);
      });
    } else {
      this.filteredLine.nonEditedLines = linesInfo.lines;
    }
  }
}
